export function jsonToFormData(jsonData) {
    const formData = new FormData();

    function convertToFormData(data, parentKey = '') {
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                const newKey = parentKey ? `${parentKey}[${key}]` : key;
                if (typeof data[key] === 'object' && data[key]!== null) {
                    convertToFormData(data[key], newKey);
                } else {
                    formData.append(newKey, data[key]);
                }
            }
        }
    }

    convertToFormData(jsonData);
    return formData;
}